import { FeatureFlags } from '@givebacks/api/feature';
import { featureFactory } from 'features';

import { FeatureNames, UserFeatureFlags } from './flags.types';

type featureContext = {
  causeId?: string;
};

type DynamicUseProps = featureContext;

type CoreFeatureFlags = UserFeatureFlags | FeatureNames | FeatureFlags;

const {
  IfFeatureState: IfFeatureState_Core,
  FeatureProvider,
  useFeatureFlag: useFeatureFlag_Core,
  useFeaturesContext: useFeaturesContext_Core,
} = featureFactory<CoreFeatureFlags, featureContext, DynamicUseProps>();

export { FeatureProvider, IfFeatureState_Core, useFeatureFlag_Core, useFeaturesContext_Core };
